import React, { useState, memo } from "react";
import { Menu, MenuItem } from "@mui/material";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";
import DropdownButton from "../DropdownButton";
import { useAnalytics } from "../../context/AnalyticsContext";
import { DROPDOWN } from "../../utils/designTokens";

// Preset options
const PRESET_OPTIONS = [
  { key: "last_week", label: "Last Week" },
  { key: "last_month", label: "Last Month" },
  { key: "last_quarter", label: "Last Quarter" },
  { key: "last_6_months", label: "Last 6 Months" },
  { key: "last_year", label: "Last Year" },
];

const DateRangeSelector = memo(function DateRangeSelector() {

  const {
    selectedPresetKey, 
    handlePresetChange
  } = useAnalytics();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePresetSelect = (presetKey) => {
    handlePresetChange(presetKey);
    handleClose();
  };

  const getSelectedPresetLabel = () => {
    const selectedOption = PRESET_OPTIONS.find(option => option.key === selectedPresetKey);
    return selectedOption ? selectedOption.label : "Select Range";
  };

  return (
    <>
      <DropdownButton
        label="Timeframe"
        value={getSelectedPresetLabel()}
        icon="date_range"
        onClick={handleClick}
      />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            backgroundColor: DROPDOWN.background,
            backdropFilter: DROPDOWN.backdropFilter,
            border: DROPDOWN.border,
            borderRadius: DROPDOWN.borderRadius,
            width: "230px",
            padding: "8px", 
          }
        }}
      >
        {PRESET_OPTIONS.map((option) => (
          <MenuItem
            key={option.key}
            selected={option.key === selectedPresetKey}
            onClick={() => handlePresetSelect(option.key)}
            sx={{
              color: DROPDOWN.textColor,
              borderRadius: '8px',
              margin: '4px 0',
              padding: '8px 12px',
              fontSize: '12px',
              '&:hover': {
                backgroundColor: DROPDOWN.itemHover,
              },
              '&.Mui-selected': {
                color: "#fff",
                backgroundColor: DROPDOWN.selectedBg,
                '&:hover': {
                  backgroundColor: DROPDOWN.selectedHover,
                },
              },
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});

export default DateRangeSelector;
